import type { TView } from '@alfa-bank/site-text-v2/src/models';
import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';

export const configDesktop = {
    title: {
        view: 'large' as TView,
    },
    descriptionContainer: {
        width: 'auto',
        marginTop: 40,
        borderRadius: 32,
    } as IStyler,
};

export const configMobile = {
    title: {
        view: 'medium' as TView,
    },
    descriptionContainer: {
        width: 752,
        borderRadius: 24,
        paddingTop: 24,
        paddingBottom: 24,
        paddingLeft: 16,
        paddingRight: 16,
        marginTop: 24,
        marginRight: 8,
        marginBottom: 0,
        marginLeft: 8,
    } as IStyler,
};
